/** Shared LiveKit participant helpers for meeting UI. */

export function parseParticipantMetadata(participant) {
  try {
    const raw = participant?.metadata;
    if (!raw || String(raw).trim() === '') return null;
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}

export function isAgentParticipant(participant) {
  if (!participant) return false;
  if (participant.isAgent) return true;
  const kind = participant.kind;
  if (kind === 'agent' || kind === 'AGENT' || kind === 4) return true;
  const identity = String(participant.identity || '').toLowerCase();
  if (['sage', 'copilot', 'meetgeek-copilot', 'agent-'].some((t) => identity.includes(t))) {
    return true;
  }
  const meta = parseParticipantMetadata(participant);
  if (meta?.isAgent === true || meta?.isAgent === 'true' || meta?.isAgent === 1) return true;
  if (meta?.role === 'copilot' || meta?.role === 'agent') return true;
  return false;
}

export function getParticipantDisplayName(participant, fallback = '') {
  const meta = parseParticipantMetadata(participant);
  const fromMeta = String(meta?.name || '').trim();
  const fromName = String(participant?.name || '').trim();
  const fromIdentity = String(participant?.identity || '').trim();
  const fromFallback = String(fallback || '').trim();
  // Prefer human display name; skip generic placeholders
  const candidates = [fromMeta, fromName, fromIdentity, fromFallback].filter(
    (value) =>
      value &&
      value.toLowerCase() !== 'participant' &&
      value.toLowerCase() !== 'unknown'
  );
  return candidates[0] || fromFallback || fromIdentity || fromName || 'Participant';
}

export function getParticipantRole(participant) {
  const meta = parseParticipantMetadata(participant);
  if (meta?.role === 'host' || meta?.isHost === true || meta?.isHost === 'true') {
    return 'host';
  }
  if (meta?.role === 'candidate') return 'candidate';
  if (meta?.role === 'team') return 'team';
  return 'participant';
}

export function avatarColorForName(name) {
  const palette = ['#22c55e', '#9048fb', '#4285F4', '#f59e0b', '#ec4899', '#14b8a6'];
  const str = String(name || '?');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i) * (i + 1)) % palette.length;
  }
  return palette[hash];
}

export function shortRoomCode(roomName) {
  if (!roomName) return '—';
  const parts = String(roomName).split('-');
  const last = parts[parts.length - 1] || roomName;
  return last.slice(0, 8);
}
